import React, { useState } from "react";
import "./Order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";
import Review_Modal from "../../../common-components/common-modals/review_modal/Review_Modal";
import Lense_prescription_modal_show from "../../../common-components/common-modals/want-buy-modal/Lense_prescription_modal_show";
import Blue_Round_Btn from "../../../common-components/common-btn/blue_round_btn/Blue_Round_Btn";

function Order_details_table({ product, dontShowPrice, order }) {
  console.log("props", dontShowPrice);

  const [showModal, setShowModal] = useState(false);

  const [productId, setProductId] = useState(false);

  const [lensemodal, setLensemodal] = useState(false);
  // const handelclick = async (id) => {
  //   // await setId(id);
  //   setLensemodal(true);
  // };

  const handelclick = async (prescription) => {
      try {
        if (prescription?.pdf) {
          const fileUrl = `${process.env.REACT_APP_IMAGE_URL}${prescription.pdf}`;
          console.log("FILE URL =", fileUrl);
  
          const response = await fetch(fileUrl);
  
          if (!response.ok) {
            alert("File not found on server");
            return;
          }
  
          const blob = await response.blob();
          const fileType = blob.type;
  
          // PDF download
          if (fileType === "application/pdf") {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Invoice.pdf";
            link.click();
            window.URL.revokeObjectURL(url);
            return;
          }
  
          // Image download (jpg, jpeg, png, webp)
          if (fileType.startsWith("image/")) {
            const extension = fileType.split("/")[1]; // jpeg, png, etc.
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `Invoice.${extension}`;
            link.click();
            window.URL.revokeObjectURL(url);
            return;
          }
  
          // Unsupported file
          alert("Unsupported file type");
        } else {
          
          setLensemodal(true);
        }
      } catch (error) {
        console.error("Download failed:", error);
        alert("Failed to download file");
      }
    };
  return (
    <>
      <div className="product_content_holder">
        <div className="product_content">
          <div className="product_detail_inner">
            <div className="left_side">
              <div className="img_holder">
                <img
                  src={
                    process.env.REACT_APP_IMAGE_URL + product?.Product?.image
                  }
                />
              </div>

              <div className="text_holder">
                <div className="product_name">
                  <p>{product?.Product?.name}</p>
                </div>
                <div className="weight">
                  <p>
                    Lens Type : {product?.Prescription?.LensType?.name || "NA"}
                  </p>
                </div>
                <div className="weight">
                  <p>Addon : {product?.Prescription?.Addon?.name || "NA"}</p>
                </div>
                 <div className="weight">
                  <p>Lense : {product?.Prescription?.Lense?.name || "NA"}</p>
                </div>

                {!product?.status && (
                  <div className="weight">
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      Order Cancel
                    </p>
                  </div>
                )}

                 {!product?.return_status && (
                  <div className="weight">
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      Order Return
                    </p>
                  </div>
                )}
              </div>
              {product?.Prescription && (
                <div className="view_btn">
                  <Blue_Round_Btn
                    btnText={"View"}
                    onClick={() => {
                      handelclick(product?.Prescription);
                    }}
                  />
                </div>
              )}
            </div>

            <div>
              <div className="qty_holder">
                <p>
                  x {product?.quantity}{" "}
                  {!dontShowPrice && (
                    <span className="price">
                      ₹ {Number(product?.selling_price).toFixed(2)}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                      "/assets/images/home/frames/frame2.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                 <p>Frame2</p>
                </div>
                <div className='weight'>
                  <p>0.5kg</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
               <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div> */}
        </div>
        {Number(order?.order_status_id) === 5 &&
          product?.Rating_Review === null && (
            <button
              className="reviewbtn"
              onClick={() => {
                setShowModal(true);
              }}
            >
              Write Review
            </button>
          )}
      </div>

      <Review_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        product={product}
        order={order}
      />

      <Lense_prescription_modal_show
        id={product?.Prescription?.id}
        // product={product}
        // variant={variant}
        // product_id={product_id}
        // lensId={lensId}
        // lensOptionId={lensOptionId}
        show={lensemodal}
        onHide={() => setLensemodal(false)}
      />
    </>
  );
}

export default Order_details_table;
